var map = {
	"./avanga2-spa-module-bpa/src/feture/index.js": 1311,
	"./avanga2-spa-module-people-spa/src/feture/index.js": 1312,
	"./avanga2-spa-module-whr/src/feture/index.js": 1488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1310;